/* eslint-disable no-use-before-define */
import h from 'hyperscript';
import { t } from 'javascripts/utils/withTranslation';
import randomId from 'javascripts/utils/random-id';
import generateIcon from 'components/_particles/icon/icon';

class CopyrightInteractive {
  constructor($el) {
    this.$copyright = $el;
    if (
      !this.$copyright ||
      this.$copyright.getAttribute('data-copyright-initialized') === 'true'
    )
      return;
    this.isExpanded = false;
    this.initCopyrightPopup();
  }

  initCopyrightPopup = () => {
    const id = `copyright-${randomId()}`;
    const $text = this.$copyright.querySelector('.copyright__text');
    const $icon = this.$copyright.querySelector('.icon');
    $icon?.removeAttribute('aria-label');
    $icon?.setAttribute('aria-hidden', 'true');
    $icon?.setAttribute('role', 'presentation');
    const $trigger = this.$copyright.querySelector('.copyright__trigger');
    const $close = this.$copyright.querySelector('.copyright__close');
    const decorativeImageLabelSuffix = this.getDecorativeImageLabelSuffix();
    const openLabel = `${t('Copyright Info öffnen')}${decorativeImageLabelSuffix}`;
    const closeLabel = `${t('Copyright Info schließen')}${decorativeImageLabelSuffix}`;

    this.$trigger =
      $trigger ||
      h(
        'button.copyright__trigger',
        {
          ariaLabel: openLabel,
          ariaExpanded: 'false',
          type: 'button',
        },
        $icon,
      );
    this.$close =
      $close ||
      h(
        'button.copyright__close',
        {
          ariaLabel: closeLabel,
          type: 'button',
        },
        generateIcon({ icon: 'close' }),
      );
    $text.id = id;
    this.$trigger.setAttribute('aria-controls', id);
    if (!$trigger) {
      this.$copyright.prepend(this.$trigger);
    }
    this.$copyright.classList.add('copyright--interactive');
    this.$copyright.setAttribute('data-copyright-initialized', 'true');

    const onMouseupBinded = this.onMouseup.bind(this);
    const onKeydownBinded = this.onKeydown.bind(this);

    this.initEvents();
  };

  getDecorativeImageLabelSuffix = () => {
    const $figure = this.$copyright.closest('.js-figure');
    const $picture = $figure?.querySelector('.picture__image');
    const alt = $picture?.getAttribute('alt');
    const isDecorative = alt === '' || alt === null || alt === ' ';

    if (!isDecorative) {
      return '';
    }

    return ` (${t('Bild ist dekorativ')})`;
  };

  initEvents = () => {
    this.$copyright.addEventListener('mouseup', this.onMouseup);
    this.$copyright.addEventListener('keydown', this.onKeydown);
  };

  deconstructor($destroyCopyright) {
    const $c = $destroyCopyright || this.$copyright;
    const $icon = $c?.querySelector('.icon');
    $c?.removeEventListener('mouseup', this.onMouseup);
    $c?.removeEventListener('keydown', this.onKeydown);
    $c?.prepend($icon);
    $c?.querySelector('.copyright__trigger')?.remove();
    $c?.querySelector('.copyright__close')?.remove();
    $c?.classList.remove('copyright--interactive');
    $c?.classList.remove('copyright--open');
    this.isExpanded = false;
  }

  onMouseup = (event) => {
    if (
      !window.getSelection().toString().length ||
      window.getSelection().toString().length < 2
    ) {
      if (this.isExpanded) {
        this.closePopup();
      } else this.openPopup();
    }
  };

  closePopup = () => {
    this.isExpanded = false;
    this.$trigger.setAttribute('aria-expanded', false);
    this.$copyright.classList.remove('copyright--open');
    this.$close.remove();
    this.$close.removeEventListener('click', this.onCloseClick);
    this.$trigger.focus();
  };

  openPopup = () => {
    this.isExpanded = true;
    this.$trigger.setAttribute('aria-expanded', true);
    this.$copyright.classList.add('copyright--open');
    if (!this.$copyright.querySelector('.copyright__close')) {
      this.$copyright.append(this.$close);
    }
    this.$close.addEventListener('click', this.onCloseClick);
    this.$copyright.querySelector('.copyright__text')?.focus();
  };

  onKeydown = (event) => {
    if (event.key === 'Escape') {
      this.closePopup();
      this.$trigger?.focus();
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      if (this.isExpanded) {
        this.closePopup();
        this.$trigger?.focus();
      } else {
        this.openPopup();
        this.$close?.focus();
      }
    }
  };

  onCloseClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    this.closePopup();
  };
}

document
  .querySelectorAll('.copyright--interactive')
  .forEach(($el) => new CopyrightInteractive($el));

export default CopyrightInteractive;
